import { render, staticRenderFns } from "./SoftbookServicePackPage.vue?vue&type=template&id=79a62e70&"
import script from "./SoftbookServicePackPage.ts?vue&type=script&lang=ts&"
export * from "./SoftbookServicePackPage.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SoftbookServicePackPage.vue"
export default component.exports